import { RenderFunction, RenderModule } from './types';
import {
  shouldRenderWhenNotRenderedYet,
  setAttributesToBlock,
  executeScript,
  appendCSSToElement,
} from './utils';

export const render: RenderFunction<'after-html' | 'blocks-element-after'> = (
  element,
  { html, style, script, blockAttributes, variationId },
) => {
  if (!html) return;
  const fragment = document.createElement('template');
  fragment.innerHTML = html;
  const renderedElement = fragment.content?.firstElementChild || fragment.firstElementChild;
  if (!renderedElement) return;
  if (style) appendCSSToElement(renderedElement, style);
  setAttributesToBlock({ element: renderedElement, blockAttributes, elementAttributes: [] });
  element.parentNode?.insertBefore?.(renderedElement, element.nextElementSibling);
  if (script) executeScript({ script, variationId });
};

export const create = (): RenderModule<'after-html' | 'blocks-element-after'> => {
  return {
    render,
    shouldRender: shouldRenderWhenNotRenderedYet,
  };
};
